import React, { useState, useCallback, useEffect } from "react";
import { Form, Spin, Select } from "antd";
import APIClient from "../../helpers/BusApiClient";

import queryString from "query-string";
const { Option } = Select;
const AutoCompleteSelect = (props) => {
 console.log(props)
  useEffect(() => {
    let value = props.refName.current.props.value;
    const citySearchParams = queryString.parse(value);

    if (!value || value == "" || value == " ") {
      return;
    }
    fetchData(citySearchParams.cityName, citySearchParams.cityId);
  }, [props.refName.current]);

  

  const onSelect = () => {
    if (props.focusRef) {
      props.handleOnSubmit(props.focusRef);
    }
  };

  const [details, setDetails] = useState({
    data: [],
    fetching: false,
  });
  useEffect(() => {
    if (details.data.length === 1) {
      const onlyCity = details.data[0];
      if (props.onSelect) {
        props.onSelect(onlyCity.code, onlyCity); // trigger onSelect handler
      }
    }
  }, [details.data, props]);

  const debounceOnChange = useCallback(debounce(fetchData, 800), []);

  const createOptions = (results, code) => {
    let arr = [];
    if (code != null) {
      results = results.filter((item) => item.code == code);
    }
    results.forEach((result) => {
      arr.push({
        code: `cityName=${result.name}&cityId=${result.code}`,
        name: result.name,
      });
    });

    return arr;
  };

  function fetchData(value, code = null) {
    if (value && value.trim()) {
      //setDetails({ data: [], fetching: true });
      setDetails((prev) => ({ ...prev, data: [], fetching: true }));
      APIClient.get(`${props.api}${value}`)
        .then((res) => {
          if (res) {
            // setDetails({
            //   data: createOptions(res.cities, code),
            //   fetching: false,
            // });
            setDetails((prev) => ({
              ...prev,
              data: createOptions(res.cities, code),
              fetching: false,
            }));
            return;
          }
          setDetails({ data: [], fetching: false });
        })
        .catch((error) => {
          console.error(error);
          setDetails({ data: [], fetching: false });
        });
    }
  }

  function debounce(func, wait) {
    let timeout;
    return function (...args) {
      const context = this;
      if (timeout) clearTimeout(timeout);
      timeout = setTimeout(() => {
        timeout = null;
        func.apply(context, args);
      }, wait);
    };
  }

  return (
    <Form.Item {...props.formItemProps}>
      <Select
        style={{ width: "100%" }}
        showSearch
        ref={props.refName}
        notFoundContent={
          details.fetching ? <Spin size="small" /> : "No Matches found."
        }
        filterOption={false}
        // onSearch={debounceOnChange}
        onSearch={fetchData}
        {...props.selectProps}
        onSelect={onSelect}
         value={
          details.data.length === 1 ? details.data[0].code : props.selectProps?.value
        }
      >
        
        {details.data.map((d) => (
          <Option value={d.code} key={"City" + d.code}>
            {d.name}
          </Option>
        ))}
      </Select>
    </Form.Item>
  );
};

export default AutoCompleteSelect;
